/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Copy_Failed_HintInputs */

const en_mcp_copy_failed_hint = /** @type {(inputs: Mcp_Copy_Failed_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't copy. Select the text and copy it yourself.`)
};

const es_mcp_copy_failed_hint = /** @type {(inputs: Mcp_Copy_Failed_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo copiar. Selecciona el texto y cópialo tú.`)
};

/**
* | output |
* | --- |
* | "Couldn't copy. Select the text and copy it yourself." |
*
* @param {Mcp_Copy_Failed_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_copy_failed_hint = /** @type {((inputs?: Mcp_Copy_Failed_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Copy_Failed_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_copy_failed_hint(inputs)
	return en_mcp_copy_failed_hint(inputs)
});